module.exports = __webpack_public_path__ + "assets/img/collect-cards-bg.dadb61b2.png";